import { PaymentMethods } from 'constants/payment';
import { analyticSystemNumberMapper } from './constants';

import { ISubscription } from 'types/subscription';

export const getValidateRecord = (cancelCandidate: ISubscription | null, order: any) => {
    const validateRecord: Record<string, unknown> = {
        subscription_id: order?.subscription_id,
        payment_type: 'lifetime',
        payment_method: analyticSystemNumberMapper[cancelCandidate?.payment_method ?? PaymentMethods.apple_pay],
        product_code: cancelCandidate?.product_code,
        product_type: cancelCandidate?.product_type,
        order_id: order?.order_id,
        order_type: 'fee_charge',
    };

    if (cancelCandidate?.subscription_trial_period) {
        validateRecord.subscription_trial_period = cancelCandidate.subscription_trial_period;
    }

    if (cancelCandidate?.subscription_period) {
        validateRecord.subscription_period = cancelCandidate.subscription_period;
    }

    return validateRecord;
};
